var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43701 0H8.69562L14 5.52891V16.2827C14 17.6298 12.9101 18.7197 11.5676 18.7197H2.43701C1.08987 18.7197 3.84967e-10 17.6298 3.84967e-10 16.2827V2.43701C-2.36519e-05 1.08987 1.08985 0 2.43701 0Z",
    fill: "#E5252A"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69141 0V5.4868H12.0005L6.69141 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.708984 13.9662V10.5469H2.16372C2.52389 10.5469 2.80924 10.6451 3.0244 10.8462C3.23956 11.0427 3.34716 11.3093 3.34716 11.6414C3.34716 11.9735 3.23956 12.2402 3.0244 12.4366C2.80924 12.6378 2.52389 12.736 2.16372 12.736H1.58369V13.9662H0.708984ZM1.58369 11.9923H2.06549C2.19645 11.9923 2.29936 11.9642 2.36954 11.8987C2.43969 11.8379 2.47713 11.7537 2.47713 11.6415C2.47713 11.5292 2.43972 11.445 2.36954 11.3842C2.29939 11.3187 2.19648 11.2906 2.06549 11.2906H1.58369V11.9923ZM3.70731 13.9662V10.5469H4.91881C5.15736 10.5469 5.38189 10.5796 5.59237 10.6498C5.80286 10.7199 5.99465 10.8182 6.16303 10.9538C6.33144 11.0848 6.46708 11.2625 6.56531 11.4871C6.65886 11.7116 6.71032 11.9689 6.71032 12.2589C6.71032 12.5442 6.65888 12.8015 6.56531 13.026C6.46708 13.2505 6.33144 13.4283 6.16303 13.5592C5.99463 13.6949 5.80286 13.7931 5.59237 13.8633C5.38189 13.9334 5.15736 13.9662 4.91881 13.9662H3.70731ZM4.56331 13.2225H4.81589C4.95154 13.2225 5.07784 13.2084 5.19478 13.1757C5.30703 13.1429 5.41463 13.0915 5.51754 13.0213C5.61577 12.9512 5.69529 12.8529 5.75141 12.722C5.80754 12.591 5.83562 12.4366 5.83562 12.2589C5.83562 12.0764 5.80754 11.9221 5.75141 11.7911C5.69529 11.6602 5.61577 11.5619 5.51754 11.4918C5.41463 11.4216 5.30706 11.3701 5.19478 11.3374C5.07784 11.3047 4.95154 11.2906 4.81589 11.2906H4.56331V13.2225ZM7.15002 13.9662V10.5469H9.58237V11.2906H8.02473V11.8379H9.26896V12.5769H8.02473V13.9662H7.15002Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.39b6480f.svg";
export { ForwardRef as ReactComponent };